import { useaxios } from "../../../utils/useaxios";
export default (company_invoice_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('company_invoice/delete.php', { company_invoice_id }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'filtercompanyinvoiceitem', payload: company_invoice_id })
            setrecaller(recaller + 1);
        } else {
            clear();
        }
        // setloading(false);
    });
}